import React, { useState, useEffect } from "react"

const times = ["12:00","1:00","2:00","3:00","4:00","5:00","6:00","7:00","8:00","9:00","10:00","11:00"]

export default function IdleClock() {
  const [activeIndex, setActiveIndex] = useState(9)
  const [isActive, setIsActive] = useState(false)
  const [period, setPeriod] = useState("AM")
  useEffect(() => {
    if (!isActive) return
    const interval = setInterval(() => {
      setActiveIndex(prev => {
        const next = (prev + 1) % 12
        if (next === 0) {
          setPeriod(p => p === "AM" ? "PM" : "AM")
        }
        return next
      })
    }, 3000)
    return () => clearInterval(interval)
  }, [isActive])

  useEffect(() => {
    let timeout
    const handleActivity = () => {
      setIsActive(false)
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setActiveIndex(9)
        setPeriod("AM")
        setIsActive(true)
      }, 100000)
    }
    const events = ["mousemove","mousedown","touchstart","keydown","pointermove","pointerdown"]
    events.forEach(e => window.addEventListener(e, handleActivity))
    handleActivity()
    return () => {
      clearTimeout(timeout)
      events.forEach(e => window.removeEventListener(e, handleActivity))
    }
  }, [])

  return (
    <div className={`idle-screen flex h2 ${isActive ? "is-active" : ""}`}>
      <div className='idle-screen__bg bg-image pos-rel'>
        <video src='https://player.vimeo.com/progressive_redirect/playback/1179486370/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=67281bb3dd3efdc6f9ae29238055a8eff1322bf88871546cbb632601ac1b38df' autoPlay muted loop playsInline className='bg-image' />
      </div>
      <AmPm period={period}/>
      <Clock activeIndex={activeIndex}/>
    </div>
  )
}

const AmPm = ({ period }) => {
  return (
    <div className='bg-image flex'>
      <div className='idle-clock__period mta mba m-mb0 m-mla m-mra pos-rel z-2 white flex gap-16 p16'>
        <span className={period === "AM" ? "" : "op-50"}>AM</span>
        <span className={period === "PM" ? "" : "op-50"}>PM</span>
      </div>
    </div>
  )
}

const Clock = ({ activeIndex }) => {
  const radius = 44

  return (
    <div className='clock--modal white p16 mr20'>
      {times.map((time, i) => {
        const angle = ((i * 30) - 90) * (Math.PI / 180)
        const x = 50 + Math.cos(angle) * radius
        const y = 50 + Math.sin(angle) * radius
        const edgeClass =
          i === 0 ? "edge-top" :
          i === 3 ? "edge-right" :
          i === 6 ? "edge-bottom" :
          i === 9 ? "edge-left" : ""
        const activeClass = i === activeIndex ? "active" : ""
        return (
          <div key={time} className={`clock-time ${edgeClass} ${activeClass}`} style={{ left: `${x}%`, top: `${y}%` }}>
            {time}
          </div>
        )
      })}
    </div>
  )
}